export default __webpack_public_path__ + "6c8508860b5e480112ca9324467dd31c.png";